import { Breadcrumb } from "@gull";
import { useCallback, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

import HandyScroll from "app/common/Scroll";
import usePagePermission from "app/hooks/usePagePermission";
import queryString from "app/services/queryStringService";

import moment from "moment";
import { Helmet } from "react-helmet";

import {
  addUpdateAreaSalesManager,
  getAreaSalesManager,
} from "app/services/RegionService";

import { Button, Col, Dropdown, DropdownButton, Row } from "react-bootstrap";

import { FaPlus, FaUserCheck } from "react-icons/fa";
import { MdOutlineRefresh, MdSearch } from "react-icons/md";

import { NotificationManager } from "react-notifications";

import AddUpdateAllSeg from "../Components/AddUpdateAllSeg";

function AreaSalesManager() {
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();

  // ===============================
  // STATES
  // ===============================

  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);

  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);

  const initialData = {
    id: 0,
    firstName: "",
    lastName: "",
    userName: "",
    email: "",
    phoneNumber: "",
    address: "",
    password: "",
    regionId: 0,
    parent: null,
    area: null,
  };

  const [formData, setFormData] = useState(initialData);
  const initialDataFilter = {
    fromDate: "",
    toDate: "",
    username: "",
    email: "",
    phoneNumber: "",
  };
  const [filters, setFilters] = useState(initialDataFilter);

  // ===============================
  // MODAL
  // ===============================

  const handleCloseModal = () => {
    setShowModal(false);
    resetForm();
  };

  const handleOpenModal = () => {
    setFormData(initialData);
    setShowModal(true);
  };

  // ===============================
  // INPUT CHANGE
  // ===============================

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // ===============================
  // RESET FORM
  // ===============================

  const resetForm = () => {
    setFormData(initialData);
  };

  // ===============================
  // SUBMIT
  // ===============================

  const handleSubmit = async (values) => {
    debugger;

    try {
      setBtnLoading(true);

      const payload = {
        id: values.id,
        firstName: values.firstName,
        lastName: values.lastName,
        userName: values.userName,
        email: values.email,
        phoneNumber: values.phoneNumber,
        address: values.address,
        password: values.id == 0 ? values.password : "",
        areaId: values.area.id,
        parentUserId: values.parent.id,
      };
      debugger;
      const res = await addUpdateAreaSalesManager(payload);

      if (res.data.status === "Success") {
        NotificationManager.success(res.data.message);
      } else {
        NotificationManager.error(res.data.message);
      }

      handleCloseModal();
      loadSalesManager();
    } catch (error) {
      console.error(error);

      NotificationManager.error("Something went wrong");
    } finally {
      setBtnLoading(false);
    }
  };

  // ===============================
  // EDIT
  // ===============================

  const handleEdit = (row) => {
    debugger;
    setFormData({
      id: row.userId || 0,
      firstName: row.firstName || "",
      lastName: row.lastName || "",
      userName: row.username || "",
      email: row.email || "",
      phoneNumber: row.phoneNumber || "",
      address: row.address || "",
      password: "",
      regionId: row.regionId || 0,
      parent: {
        id: row.parentId,
        label: row.parentName,
      },
      area: {
        id: row.areaId,
        label: row.areaName,
      },
    });

    setShowModal(true);
  };

  // ===============================
  // DELETE
  // ===============================

  //   const handleDelete = async (row) => {
  //     try {
  //       const result = await Swal.fire({
  //         title: "Are you sure?",
  //         text: `You want to delete "${row.firstName}"`,
  //         icon: "warning",
  //         showCancelButton: true,
  //         confirmButtonColor: "#d33",
  //         confirmButtonText: "Yes, Delete",
  //         cancelButtonText: "Cancel",
  //       });

  //       if (result.isConfirmed) {
  //         const res = await deleteRegionalManager(row.id);

  //         Swal.fire({
  //           title: "Deleted!",
  //           text: res?.data?.message,
  //           icon: res?.data?.status?.toLowerCase(),
  //           timer: 2000,
  //           showConfirmButton: false,
  //           toast: true,
  //         });

  //         loadRegionalManager();
  //       }
  //     } catch (error) {
  //       console.error(error);

  //       Swal.fire({
  //         title: "Error!",
  //         text: "Something went wrong",
  //         icon: "error",
  //       });
  //     }
  //   };

  // ===============================
  // DATE FORMATTER
  // ===============================

  const dateFormatter = useCallback((cell) => {
    return cell ? (
      <div>
        <div>{moment(cell).format("DD/MM/YYYY")}</div>
        <div>{moment(cell).format("HH:mm")}</div>
      </div>
    ) : (
      "-"
    );
  }, []);

  // ===============================
  // STATUS FORMATTER
  // ===============================

  const statusFormatter = useCallback((cell) => {
    return cell !== undefined && cell !== null ? (
      <span
        style={{
          color: cell ? "green" : "red",
          fontWeight: "600",
        }}
      >
        {cell ? "Active" : "Inactive"}
      </span>
    ) : (
      "-"
    );
  }, []);

  // ===============================
  // ACTION FORMATTER
  // ===============================

  const actionFormatter = (cell, row) => {
    return (
      <DropdownButton variant="outline-primary" title="Action" size="sm">
        <Dropdown.Item className="text-primary" onClick={() => handleEdit(row)}>
          <FaUserCheck className="me-2" />
          Edit
        </Dropdown.Item>

        {/* <OverlayTrigger
          placement="top"
          overlay={
            row.status ? (
              <Tooltip>
                This Regional Manager is active and cannot be deleted
              </Tooltip>
            ) : (
              <></>
            )
          }
        >
          <span>
            <Dropdown.Item
              disabled={row.status}
              className={row.status ? "text-muted" : "text-danger"}
              onClick={() => !row.status && handleDelete(row)}
            >
              <MdDelete className="me-2" />
              Delete
            </Dropdown.Item>
          </span>
        </OverlayTrigger> */}
      </DropdownButton>
    );
  };

  // ===============================
  // TABLE COLUMNS
  // ===============================

  const columns = [
    {
      dataField: "roleId",
      text: "Action",
      formatter: actionFormatter,
      headerStyle: () => ({
        width: "130px",
        textAlign: "center",
      }),
    },
    // {
    //   dataField: "roleName",
    //   text: "Role Name",
    //   headerStyle: () => ({
    //     width: "150px",
    //     textAlign: "center",
    //   }),
    // },
    {
      dataField: "firstName",
      text: "First Name",
      headerStyle: () => ({
        width: "150px",
        textAlign: "center",
      }),
    },
    {
      dataField: "lastName",
      text: "Last Name",
      headerStyle: () => ({
        width: "150px",
        textAlign: "center",
      }),
    },
    {
      dataField: "username",
      text: "User Name",
      headerStyle: () => ({
        width: "150px",
        textAlign: "center",
      }),
    },
    {
      dataField: "email",
      text: "Email",
      headerStyle: () => ({
        width: "200px",
        textAlign: "center",
      }),
    },
    {
      dataField: "phoneNumber",
      text: "Phone Number",
      headerStyle: () => ({
        width: "150px",
        textAlign: "center",
      }),
    },
    {
      dataField: "parentName",
      text: "Sales Manager",
      headerStyle: () => ({
        width: "200px",
        textAlign: "center",
      }),
    },
    {
      dataField: "areaName",
      text: "Area Name",
      headerStyle: () => ({
        width: "150px",
        textAlign: "center",
      }),
    },
    {
      dataField: "regionName",
      text: "Region",
      headerStyle: () => ({
        width: "150px",
        textAlign: "center",
      }),
    },
  ];

  // ===============================
  // ROW STYLE
  // ===============================

  function rowStyle() {
    return {
      textAlign: "center",
      fontWeight: "600",
      verticalAlign: "middle",
    };
  }

  // ===============================
  // NO DATA
  // ===============================

  function NoDataIndication() {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    }

    return (
      <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
        <p>No Data Found</p>
      </div>
    );
  }

  // ===============================
  // LOAD DATA
  // ===============================

  const loadSalesManager = useCallback(async () => {
    try {
      setLoading(true);

      const query = queryString.getQueryStringFromObj({
        pageNumber: page,
        pageSize: sizePerPage,
        roleName: "AreaSalesManager",
        ...filters,
      });

      const response = await getAreaSalesManager(query);

      setData(response?.data?.data || []);
      const paginationData = JSON.parse(response.headers["x-pagination"]);
      setDataCount(paginationData.TotalCount);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [filters, page, sizePerPage]);

  useEffect(() => {
    loadSalesManager();
  }, [loadSalesManager]);

  // ===============================
  // TABLE CHANGE
  // ===============================

  const handleTableChange = useCallback((type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  }, []);

  // ===============================
  // PAGE SIZE
  // ===============================

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>

      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;

          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  // ===============================
  // PAGINATION
  // ===============================

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    showTotal: true,
    totalSize: dataCount,

    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],

    sizePerPageRenderer,
  };
  const handleSearchChanges = useCallback((e) => {
    const { name, value } = e.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  }, []);
  const handleSearch = useCallback(() => {
    setPage(1);
    loadSalesManager();
  }, [loadSalesManager]);

  const refreshFilter = useCallback(() => {
    setFilters(initialDataFilter);
  }, []);
  return (
    <>
      <Helmet>
        <title>Area Sales Manager</title>
      </Helmet>

      <Breadcrumb routeSegments={[{ name: "Area Sales Manager" }]} />

      {/* ===============================
          TOP BUTTON
      =============================== */}

      <div className="d-flex justify-content-end mb-2">
        <Button variant="primary" onClick={handleOpenModal}>
          <FaPlus className="me-2" />
          Add Area Sales Manager
        </Button>
      </div>

      {/* ===============================
          TABLE
      =============================== */}
      <div className="card card-body rounded border mb-1">
        <Row>
          {/* Date From */}
          <Col md={2} col={12}>
            <label>Date From</label>
            <input
              type="date"
              className="form-control"
              name="fromDate"
              value={filters.fromDate}
              onChange={handleSearchChanges}
              max={moment().format("YYYY-MM-DD")}
            />
          </Col>
          {/* Date To */}
          <Col md={2} col={12}>
            <label>Date To</label>
            <input
              type="date"
              className="form-control"
              name="toDate"
              value={filters.toDate}
              onChange={handleSearchChanges}
              max={moment().format("YYYY-MM-DD")}
            />
          </Col>
          <Col md={2} col={12}>
            <label>User Name</label>
            <input
              type="text"
              className="form-control"
              name="username"
              value={filters.username}
              onChange={handleSearchChanges}
              placeholder="Enter User Name"
            />
          </Col>
          <Col md={2} col={12}>
            <label>Email</label>
            <input
              type="text"
              className="form-control"
              name="email"
              value={filters.email}
              onChange={handleSearchChanges}
              placeholder="Enter Email"
            />
          </Col>
          <Col md={2} col={12}>
            <label>Phone Number</label>
            <input
              type="text"
              className="form-control"
              name="phoneNumber"
              value={filters.phoneNumber}
              onChange={handleSearchChanges}
              placeholder="Enter Phone Number"
            />
          </Col>
          <Col md={2} className="d-flex justify-content-end mt-3">
            <button
              className="btn btn-outline-primary me-2"
              onClick={handleSearch}
            >
              <MdSearch size={18} />
            </button>

            <button className="btn btn-outline-primary" onClick={refreshFilter}>
              <MdOutlineRefresh size={18} />
            </button>
          </Col>
        </Row>
      </div>
      <HandyScroll>
        <div
          className="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="id"
            data={data}
            columns={columns}
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>

      {/* ===============================
          MODAL
      =============================== */}
      <AddUpdateAllSeg
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        handleSubmit={handleSubmit}
        btnLoading={btnLoading}
        initialData={formData}
        setFormData={setFormData}
        type={"Area Sales Manager"}
      />
    </>
  );
}

export default AreaSalesManager;
